module.exports = "https://static.energy5.com/_next/static/images/brand10-278ac83f28de41e8604f5370a090e0d5.png";